import React from 'react';
import { Card, Spin } from 'antd';

import StatisticsFilters from 'components/Statistics/StatisticsFilters';
import StatsAsBarChart from 'components/Statistics/StatsAsBarChart';
import StatsAsTable from 'components/Statistics/StatsAsTable';
import { NEWEST_YEAR, getDataFormatted, getStatData } from 'helpers/statisticsHelpers';
import styles from './Statistics.module.scss';


const getStatisticsContent = (dataFormatted, filters) => {
  const { zone, type, year, displayType } = filters;
  const getZone = Object.keys(dataFormatted)[zone];
  if (!getZone) {
    return <div>Aucune donnée disponible pour l'année {year}.</div>;
  }
  if (displayType === 'graph') {
    return (
      <StatsAsBarChart
        data={dataFormatted[getZone]}
        filters={filters}
        zone={getZone}
        year={year}
        displayKey={type}
      />
    );
  }
  return <StatsAsTable data={dataFormatted[getZone]} displayKey={type} year={year} />;
};

export class Statistics extends React.Component {
  state = {
    loading: true,
    data: {},
    filters: {
      displayType: 'graph',
      year: NEWEST_YEAR,
      zone: 0,
      type: 'events',
    },
  };

  componentDidMount () {
    this.fetchData(this.state.filters.year);
  }

  componentDidUpdate (prevProps, { filters: { year: prevYear } }) {
    const { filters: { year } } = this.state;
    if (prevYear !== year) {
      this.fetchData(year);
    }
  }

  componentWillUnmount () {
    this.isCancelled = true;
  }

  setFilters = filters => {
    this.setState(previousState => ({ filters: { ...previousState.filters, ...filters } }));
  };

  fetchData = async year => {
    const { activityTypes } = this.props;
    const data = await getStatData(year);
    if (this.isCancelled) return;
    this.setState({ data: getDataFormatted(data, activityTypes), loading: false });
  }

  render () {
    const { filters, data, loading } = this.state;
    const { setFilters } = this;
    return (
      <div>
        <div className={styles.header}>
          <h1 className={styles.header__title}>Statistiques des manifestations en forêt</h1>
        </div>
        {loading
          ? <Spin className={styles.loading} />
          : (
            <React.Fragment>
              <StatisticsFilters
                {...filters}
                zones={Object.keys(data)}
                onFiltersChange={setFilters}
              />
              <Card
                className={styles.statistics}
              >
                {getStatisticsContent(data, filters)}
              </Card>
            </React.Fragment>
          )}
      </div>
    );
  }
}

export default Statistics;



// WEBPACK FOOTER //
// ./src/components/Statistics/Statistics.js